import { defineStore } from "pinia";
import type { BreadcrumbsCategory } from "~/types/composables/useCategoryTypes";

interface State {
	pageTitle: string;
	pageType: string;
	categoryBreadcrumb: BreadcrumbsCategory | null;
	suppressI18nHead: boolean;
}

export const usePageStore = defineStore("pageStore", {
	state: (): State => ({
		pageTitle: "",
		pageType: "", // cms, home, category, product, cart, checkout, blog, blog-category, article
		categoryBreadcrumb: null,
		suppressI18nHead: false
	}),
	actions: {
		setPageTitle(page: string) {
			this.pageTitle = page;
		},
		setPageType(type: string) {
			this.pageType = type;
		},
		setCategoryBreadcrumb(category: BreadcrumbsCategory) {
			this.categoryBreadcrumb = category;
		},
		setSuppressI18nHead(value: boolean) {
			this.suppressI18nHead = value;
		}
	}
});
